import Cookies from 'js-cookie';

$(function () {
  const announcementBar = document.querySelector('.announcement-bar');
  if (!announcementBar) return;

  window.dAgency.announcementBarHeight = 0;
  var isAnnouncementClosed = 'true';

  if (typeof Cookies === 'function') {
    isAnnouncementClosed = Cookies.get('CLOSED_ANNOUNCEMENT') == 'true' ? 'true' : 'false';
  }

  if (isAnnouncementClosed == 'false') {
    $(announcementBar).slideDown(function () {
      window.dAgency.announcementBarHeight = announcementBar.clientHeight;
      window.dAgency.headerHeight = window.dAgency.headerHeight + window.dAgency.announcementBarHeight;
      const announcementOpeningEvent = new Event('announcementOpeningEvent');
      document.dispatchEvent(announcementOpeningEvent);
    });
  }

  const closeAnnouncement = announcementBar.querySelector('.announcement-bar__close');
  closeAnnouncement.addEventListener('click', () => {
    $(announcementBar).slideUp();
    window.dAgency.headerHeight = window.dAgency.headerHeight - window.dAgency.announcementBarHeight;
    window.dAgency.announcementBarHeight = 0;

    if (typeof Cookies === 'function') {
      Cookies.set('CLOSED_ANNOUNCEMENT', 'true');
    }

    const announcementClosingEvent = new Event('announcementClosingEvent');
    document.dispatchEvent(announcementClosingEvent);
  });

  const messages = announcementBar.querySelector('.announcement-bar__messages');
  if (messages && messages.querySelectorAll('.swiper-slide').length > 1) {
    const announcementsSwiper = new Swiper(messages, {
      loop: true,
      direction: 'vertical',
      allowTouchMove: false,
      autoplay: {
        delay: 5000
      }
    });
  }
});
